import {sbxCoreService} from "../Network";

export function getPaymentTypes() {
  return sbxCoreService.with("customer_payment_type").loadAll();
}
